export default __webpack_public_path__ + "static/media/MILLERLogo.0cea2331.jpg";